import ReactPlayer from 'react-player';
import { Col } from '@design-system/components/grid/grid';
import { Typography } from '@design-system/components/typography/typography';
import { wrapper } from './ExclusiveSubscription.css';

export const ExclusiveSubscriptionInfo = () => (
  <div className={wrapper}>
    <Typography variant="headline" size="large">
      Exclusive Subscription is here!
    </Typography>
    <Col gap="xl">
      <Typography variant="body" size="large">
        Starting your Exclusive Subscription is a great opportunity to grow your
        following with flexibility and higher revenue potential.
      </Typography>
      <Typography variant="body" size="large">
        Our 1-minute explainer will help you make the right tradeoffs between
        your Platform and your Exclusive subscription.
      </Typography>
    </Col>
    <ReactPlayer
      url="https://stream.mux.com/01Tvi26FBzWnnQkY9MevZdihZqa01aS7fiLd00xIgBeWWI.m3u8"
      controls={true}
      className="w-full"
    />
  </div>
);
